function BundlePopUpDetailManage() {
  this.container = $("#bp_detail");
  this.product_handle;
  this.product;
  this.variant_pointer;
  this.variant_id;
  this.product_js;
  this.carousel;
  this.carousel_thumbnail;
}
BundlePopUpDetailManage.prototype.close = function () {
  $(this.container).hide();
  $("body").css("overflow", "auto");
};
BundlePopUpDetailManage.prototype.add = function () {
  //console.log( this.product );
  //$("#app").find("[data-id='"+this.product.id+"']").trigger('click');
  console.log(this.variant_id);
  $("#app")
    .find("[data-variant_id='" + this.variant_id + "']")
    .trigger("click");
  this.close();
};
BundlePopUpDetailManage.prototype.load = function () {
  let that = this;

  this.carousel = $("#bp_detail_main");
  //let obj_carousel_thumbnail = $(this.container).find(".product-images__thumbs:lt(1)");
  //this.carousel_thumbnail = $(this.container).find(".product-images__thumbs:lt(1)");
  //this.carousel_thumbnail = $(this.container).find("#bp_detail_thumbs");
  this.carousel_thumbnail = $("#bp_detail_thumbs");

  //Cick outside
  $("html").click(function (event) {
    let obj = $(event.target).closest(".bp_box_container");
    if (obj.length == 0 && $(".bp_box_container").is(":visible")) {
      __BPDM.close();
    }
  });

  $("body").css("overflow", "hidden");
  $.ajax({
    type: "GET",
    url: "/products/" + that.product_handle + ".json",
    success: function (msg) {
      that.render(msg.product);
    },
    error: function (XmlHttpRequest, textStatus, errorThrown) {
      //alert("fail:"+XmlHttpRequest.responseText);
    },
  });
  $(this.container).show();
};
BundlePopUpDetailManage.prototype.render = function (product) {
  //console.log(product);
  this.product = product;
  //let obj_carousel_main = $(this.container).find(".product-images__slider:lt(1)");

  ///*
  if ($(this.carousel).hasClass("flickity-enabled")) {
    $(this.carousel).flickity("destroy");
    $(this.carousel).html("");
  }
  if ($(this.carousel_thumbnail).hasClass("flickity-enabled")) {
    $(this.carousel_thumbnail).flickity("destroy");
    $(this.carousel_thumbnail).html("");
  }
  //*/
  let looxReviews = $("a[href='#looxReviews]'");
  looxReviews.first().remove();
  looxReviews.append('<div class="loox-rating"></div>');

  for (let key in product.images) {
    let image = product.images[key];
    $(
      "<div class='carousel-cell product-images__slide'><img src='" +
        image.src +
        "' alt='" +
        image.alt +
        "' class='featured-image'/></div>"
    ).appendTo(this.carousel);

    //$(this.carousel).flickity( 'append', $("<div class='carousel-cell'><img src='"+image.src+"' alt='"+image.alt+"' class='featured-image'/></div>") );

    $(
      "<div class='carousel-cell product-images__thumbs-slide'><img src='" +
        image.src +
        "' alt='" +
        image.alt +
        "' class='product-single__thumbnail'/></div>"
    ).appendTo(this.carousel_thumbnail);
    // data-widths='[295,394,590,700,800,999]' data-aspectratio='0.999'
    //$(this.carousel_thumbnail).flickity( 'append', $("<div class='carousel-cell'><img src='"+image.src+"'/></div>") );
  }

  let that = this;

  $(this.carousel).flickity({
    //$("#bp_detail_main").flickity({
    // options
    autoPlay: false,
    setGallerySize: true,
    wrapAround: true,
    //adaptiveHeight: true,
    //setGallerySize: true,
    //imagesLoaded: true,
    //lazyLoad: true,
    pageDots: false,
    prevNextButtons: true,
    arrowShape: {
      x0: 0,
      x1: 45,
      y1: 50,
      x2: 50,
      y2: 50,
      x3: 5,
    },
  });

  $(this.carousel_thumbnail).flickity({
    //$("#bp_detail_thumbs").flickity({
    asNavFor: "#bp_detail_main",
    cellSelector: ".carousel-cell",
    contain: true,
    pageDots: false,
    prevNextButtons: false,
  });

  setTimeout(
    function () {
      $(this.carousel).flickity("resize");
      $(this.carousel_thumbnail).flickity("resize");
      //$("#bp_detail_thumbs").flickity('resize');
    }.bind(this),
    100
  );

  //console.log(product);
  let title = product.title;
  if (product["variants"].length > 1)
    title = product["variants"][this.variant_pointer].title;
  //debugger;
  //Render info
  $(this.container).find(".product-vendor").html(product.vendor);
  $(this.container).find(".product-title").html(title);
  $(this.container).find(".product_title").html(title);

  this.product_js = getProduct(product.handle);

  //if( typeof this.product_js.metafields.bundler.details_description != undefined ){
  //Description
  $(this.container).find(".description").html("");
  if (
    this.product_js["metafields"] != null &&
    this.product_js["metafields"]["bundler"] != null &&
    this.product_js["metafields"]["bundler"]["details_description"] != null
  ) {
    //console.log(this.product_js.metafields.bundler.details_description);
    $(this.container)
      .find(".description")
      .html(this.product_js.metafields.bundler.details_description);
  } else $(this.container).find(".description").html(product.body_html);
  //console.log( this.product_js.metafields.bundler );

  if (
    typeof this.product_js.metafields != undefined &&
    typeof this.product_js.metafields.loox != undefined
  ) {
    $(this.container).find(".loox-rating").attr("data-id", product.id);
    $(this.container)
      .find(".loox-rating")
      .attr("data-rating", this.product_js.metafields.loox.avg_rating);
    $(this.container)
      .find(".loox-rating")
      .attr("data-raters", this.product_js.metafields.loox.num_reviews);
  }

  this.renderPairings();
};
BundlePopUpDetailManage.prototype.renderPairings = function () {
  $(".pairing_container").hide();
  $(".pairing_container").find(".product_list").html("");
  if (this.product_js["metafields"]["bundler"] == null) return;
  //if( !this.product_js["metafields"]["bundler"].includes("suggested_pairings") ) return;
  if (
    typeof this.product_js["metafields"]["bundler"]["suggested_pairings"] ==
    "undefined"
  )
    return;
  let pairing_products =
    this.product_js["metafields"]["bundler"]["suggested_pairings"].split(", ");
  //console.log(pairing_products);
  for (let key in pairing_products) {
    let pairing_product_js = getProduct(pairing_products[key]);
    let variant_id = pairing_product_js["variants"][0].id;
    let thumb_url = pairing_product_js["featured_image_thumb"];
    //ADD TO CART
    let title = bundleProductTitle(pairing_product_js.title);

    if (pairing_product_js.inventory_quantity == 0) {
      $(
        "<div><img src='" +
          thumb_url +
          "'/><button type='button' class='add_to_cart add_to_cart_pair' name='add' data-title='" +
          title +
          "' disabled><span>Sold Out</span></button></div>"
      ).appendTo($(".pairing_container").find(".product_list"));
    } else {
      $(
        "<div><img src='" +
          thumb_url +
          "'/><button type='button' class='add_to_cart add_to_cart_pair' name='add' onclick='event.stopPropagation();__BPDM.addPair(this," +
          variant_id +
          ")' data-title='" +
          title +
          "'><span>ADD " +
          title +
          "</span></button></div>"
      ).appendTo($(".pairing_container").find(".product_list"));
    }
  }

  $(".pairing_container").show();
};
BundlePopUpDetailManage.prototype.getTitle = function (title) {
  let tmp;
  tmp = title.split("-");
  if (tmp.length > 1) title = tmp[0];
  title = title.replace("™", "");
  if (title.length > 15) {
    tmp = title.split(" ");
    if (tmp.length > 1) title = tmp[0];
  }
  return title;
};
BundlePopUpDetailManage.prototype.addPair = function (obj, product_id) {
  let title = $(obj).attr("data-title");
  $(obj).attr("disabled", true);
  $(obj).html("ADDED " + title);
  app.addItemToBundle(product_id);
};
BundlePopUpDetailManage.prototype.show = function (
  obj,
  handle,
  variant_pointer,
  variant_id
) {
  if (window.screen.width < 1024) return;
  this.product_handle = handle;
  this.variant_pointer = variant_pointer;
  this.variant_id = variant_id;
  this.load();
  //obj.event.stopPropagation();
};
